<div class="modal-header">
    <h4 class="modal-title">Configuraci&oacute;n de bloqueo autom&aacute;tico</h4>
    <button [disabled]="grabando" type="button" class="btn-close" aria-label="Close" (click)="onCancelar()"></button>
</div>
<div class="modal-body">
    <h6 class="modal-title">Cliente: {{ cliente?.razonSocial }} - {{ cliente?.cuit }}</h6>
    <hr>
    <form [formGroup]="form">
        <div class="row mb-3 align-items-center">
            <label class="col-10 col-form-label" for="vencido">No bloquear por saldo vencido</label>
            <div class="col-2 text-end pe-6">
                <input class="form-check-input" type="checkbox" id="vencido" formControlName="noBloquearPorVencido">
            </div>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-10 col-form-label" for="vencidoFeriados">No bloquear s&aacute;bados, domingos y feriados PAD por
                saldo vencido</label>
            <div class="col-2 text-end pe-6">
                <input class="form-check-input" type="checkbox" id="vencidoFeriados"
                    formControlName="noBloquearDiasInhabilesVencido">
            </div>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-10 col-form-label" for="excedido">No bloquear por saldo excedido</label>
            <div class="col-2 text-end pe-6">
                <input class="form-check-input" type="checkbox" id="excedido" formControlName="noBloquearPorExcedido">
            </div>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-10 col-form-label" for="excedidoFeriados">No bloquear s&aacute;bados, domingos y feriados PAD por
                saldo excedido</label>
            <div class="col-2 text-end pe-6">
                <input class="form-check-input" type="checkbox" id="excedidoFeriados"
                    formControlName="noBloquearDiasInhabilesExcedido">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button  class="btn btn-primary"
        id="aceptar" [disabled]="grabando" (click)="onGuardar()">
        <span *ngIf="!grabando">Guardar cambios</span>
        <div *ngIf="grabando" class="d-flex align-items-center">
            <div class="spinner-border text-light spinner-border-sm" role="status"></div>
            <span>Guardando...</span>
        </div>
    </button>
    <button [disabled]="grabando" type="button" class="btn btn-secondary" (click)="onCancelar()">Cancelar</button>
</div>
